import { createFileRoute } from "@tanstack/react-router";
import AdminProgramOrganizationsPage from "@/pages/admin/programs/detail/organizations";
import { useProgramsPermissions } from "@/pages/admin/programs";

export const Route = createFileRoute("/app/admin/programs/$programId/organizations")({
  component: RouteComponent,
});

function RouteComponent() {
  const { programId } = Route.useParams();
  const { programs, userCanViewAllPrograms } = useProgramsPermissions();

  return (
    <AdminProgramOrganizationsPage
      program={programs.data[programId]}
      userCanViewAllPrograms={userCanViewAllPrograms}
    />
  );
}
